import React from 'react';

/**
 * DemandInput Component
 * Allows users to input demand quantity for capacity constraint calculation
 * Acts as a toggle: 0 = no capacity constraint, >0 = enable capacity constraint
 */
export default function DemandInput({ demand, setDemand }) {
  
  const handleDemandChange = (e) => {
    const value = e.target.value;
    
    // Allow empty string for clearing
    if (value === '') {
      setDemand(0);
      return;
    }
    
    // Parse as number
    const numValue = parseFloat(value);
    
    // Validate: must be non-negative number
    if (!isNaN(numValue) && numValue >= 0) {
      setDemand(numValue);
    }
  };
  
  // Determine if capacity constraint is enabled
  const isCapacityConstraintEnabled = demand > 0;
  
  return (
    <div className="demand-input-container">
      <label htmlFor="demand-quantity" className="demand-label">
        <span className="label-text">Transport Demand Quantity</span>
        <span className={`capacity-status ${isCapacityConstraintEnabled ? 'enabled' : 'disabled'}`}>
          {isCapacityConstraintEnabled ? 'Capacity Constraint Enabled' : 'Capacity Constraint Disabled'}
        </span>
      </label>
      
      <input
        id="demand-quantity"
        type="number"
        min="0"
        step="any"
        value={demand || ''}
        onChange={handleDemandChange}
        placeholder="Enter demand quantity (e.g., 1000 tons or 100 passengers)"
        className="demand-input"
      />
      
      <div className="demand-hint">
        <p className="hint-text-simple">
          <strong>Demand = 0 or empty:</strong> Standard mode (no capacity constraint)
        </p>
        <p className="hint-text-simple">
          <strong>Demand &gt; 0:</strong> Capacity constraint enabled
        </p>
      </div>
    </div>
  );
}

